// noinspection JSUnresolvedReference

const ingredientFilter = (ingredientSelect) => {
  // Get the ingredient select element
  const postsContainer = document.getElementById('ajax-posts-container');
  
  // Add event listener for changes on the select element
  ingredientSelect.addEventListener('change', () => {
    const selectedTerms = Array.from(ingredientSelect.selectedOptions).map(option => option.value);
    
    // Prepare AJAX request
    const xhr = new XMLHttpRequest();
    xhr.open('POST', ingredientAjax.ajaxUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    
    // Display loading message
    postsContainer.innerHTML = '<p>Loading...</p>';
    
    // Handle the AJAX response
    xhr.onload = function () {
      if (xhr.status === 200) {
        const response = JSON.parse(xhr.responseText);
        
        if (response.length) {
          // Build and display posts
          postsContainer.innerHTML = response.map(post => `
                        <div class="post-item">
                            <a href="${post.link}" class="cta-link">${post.title}</a>
                            <div class="excerpt">${post.excerpt}</div>
                        </div>
                    `).join('');
        } else {
          // Display no posts found message
          postsContainer.innerHTML = '<p>No cocktails found for the selected ingredients.</p>';
        }
      } else {
        // Handle errors
        postsContainer.innerHTML = '<p>An error occurred. Please try again.</p>';
      }
    };
    
    // Handle errors (e.g., network issues)
    xhr.onerror = function () {
      postsContainer.innerHTML = '<p>An error occurred. Please check your connection and try again.</p>';
    };
    
    // Send the request with data
    const data = `action=fetch_filtered_posts&security=${ingredientAjax.nonce}&post_type=${encodeURIComponent(ingredientAjax.postType)}&taxonomy=${encodeURIComponent(ingredientAjax.taxonomy)}&terms[]=${encodeURIComponent(selectedTerms.join(','))}`;
    xhr.send(data);
  });
};

export default ingredientFilter;
